import { render } from "./MenuContent.vue?vue&type=template&id=5894a27e&scoped=true"
import script from "./MenuContent.vue?vue&type=script&lang=js"
export * from "./MenuContent.vue?vue&type=script&lang=js"

import "./MenuContent.vue?vue&type=style&index=0&id=5894a27e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5894a27e"]])

export default __exports__